import { lazy, Suspense } from 'react';
import SuspenseLoader from './components/SuspenseLoader';
import { Navigate, RouteObject } from 'react-router';
import BaseLayout from './layouts/BaseLayout';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Login = Loader(lazy(() => import('src/content/auth/login')));

const authRoutes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      { path: '*', element: <Navigate to="/login" /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '/login', element: <Login /> }
    ]
  }
];

export default authRoutes;
